import { render, staticRenderFns } from "./sme-document-info.vue?vue&type=template&id=6b7f76ec&scoped=true&"
import script from "./sme-document-info.vue?vue&type=script&lang=js&"
export * from "./sme-document-info.vue?vue&type=script&lang=js&"
import style0 from "./sme-document-info.vue?vue&type=style&index=0&id=6b7f76ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7f76ec",
  null
  
)

export default component.exports